export default __webpack_public_path__ + "static/media/email.a49e0158.png";